import {Injectable} from '@angular/core';
import {ItemAutoSaveQuery, ItemAutoSaveStore} from "./item-auto-save.store";
import {instanceToInstance} from "class-transformer";
import {take} from "rxjs/operators";
import {ConfirmationDialogService, DateHelpers} from "common-shared";
import {ManufacturingItemSaveModel} from "web-shared";
import {StateService} from "web-shared";
import {ManufacturingItemModel} from "web-shared";

@Injectable({
  providedIn: 'root'
})
export class AutoSaveService {
  autoSave: boolean = false;

  constructor(private stateService: StateService, private itemAutoSaveStore: ItemAutoSaveStore, private itemAutoSaveQuery: ItemAutoSaveQuery, private confirmationService: ConfirmationDialogService) {
    this.stateService.settings$.pipe(take(1)).subscribe(value => {
      this.autoSave = value.Ime.AutoSave;
    });
  }

  updateItem(isPristine: boolean, item: ManufacturingItemModel) {
    if (this.autoSave === false || isPristine === true) return;
    if (this.itemAutoSaveQuery.hasEntity(item.Id)) {
      this.itemAutoSaveStore.remove(item.Id);
    }
    const toSave = ManufacturingItemSaveModel.createFromItem(item, this.stateService.currentUser$.value.Fullname);
    this.itemAutoSaveStore.add(toSave);
  }

  removeItem(id: string) {
    if (this.autoSave === false) return;
    this.itemAutoSaveStore.remove(id);
  }

  tryGetRestoredItem(id: string): ManufacturingItemSaveModel {
    if (this.autoSave === false) return;
    const restoredItem = this.itemAutoSaveQuery.getAll().find(item => item.Id === id);
    return instanceToInstance(restoredItem);
  }

  confirmItemRestore(item: ManufacturingItemModel, restoredItem: ManufacturingItemSaveModel) {
    const modifiedDate = DateHelpers.format(restoredItem.ModifiedDate, 'dd.MM.yyyy HH:mm:ss');
    return this.confirmationService.confirm("Restore from auto save", `A version of '${item.DisplayName}' with unsaved changes by ${restoredItem.ModifiedBy} (${modifiedDate}) was found.
    Would you like to restore it? Click yes to review changes, the item will not be overwritten unless save is pressed.`);
  }
}
